import { ConvexReactClient } from "convex/react";

const convexUrl = import.meta.env.VITE_CONVEX_URL || "https://dummy.convex.cloud";

export const convexClient = new ConvexReactClient(convexUrl);
export const hasLiveConvex = !!import.meta.env.VITE_CONVEX_URL;
